import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppChordRender } from './Render';

@NgModule({
  declarations: [
    AppChordRender
  ],
  exports: [
    AppChordRender
  ],
  imports: [
    BrowserModule,
    HttpClientModule
  ]
})
export class AppModuleChord { }
